import React from 'react'
import Login from '../../login/Login'
import { useSelector } from 'react-redux'
import { RootState } from '../../../model/rootReducer'
import LandingPage from '../../system/landingPage/LandingPage'
import _ from 'lodash'
import HomeLayout from '../../layouts/homeLayout/HomeLayout'
import UnauthorizedPage from '../../system/unauthorizedPage/UnauthorizedPage'
import { env } from '../../../helpers/env'

//@ts-ignore
export const PrivateRoute = (props) => {
  const user = useSelector((state: RootState) => state.oidc.user)
  const isInit = useSelector((state: RootState) => state.app.isInitialized)

  //@ts-ignore
  let { as: Comp } = props

  console.log('user', user)
  console.log('role', user?.profile?.role)

  if (user === undefined || user === null) {
    console.log('login')
    return <Login />
  }

  if (!_.includes(user!.profile.role, env('GRANT_ACCESS_ROLE'))) {
    console.log('home layout')
    return (
      <HomeLayout>
        <UnauthorizedPage />
      </HomeLayout>
    )
  }

  if (isInit) {
    console.log('is Init')
    return <Comp {...props} />
  } else {
    console.log('not Init')
    return <LandingPage />
  }
}

export default PrivateRoute
